import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import moment from 'moment';

import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

import { ModalCloseBtn } from '../../../components/statelessComponents/Buttons/ButtonsInModals';
import UserAvatar from '../../../components/UserAvatar/UserAvatar';
import s from './LessonChangelog.scss';

import messages from '../lessonDetailsMessages';

@withStyles(s)
@connect(state => ({
  changelog: state.lessonDetails.changelog,
}))
export default class LessonChangelog extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    lesson: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    changelog: PropTypes.arrayOf(
      PropTypes.shape({
        createDate: PropTypes.string.isRequired,
        changeDescription: PropTypes.string,
        createdBy: PropTypes.shape({
          firstName: PropTypes.string.isRequired,
          lastName: PropTypes.string.isRequired,
          image: PropTypes.string.isRequired,
        }).isRequired,
      }),
    ).isRequired,
  };

  render() {
    const { onClose, changelog, lesson } = this.props;
    return (
      <div className={s.root}>
        <Typography variant="h5" component="h1" color="primary" gutterBottom>
          <FormattedMessage
            {...messages.changelog}
            values={{
              name: lesson.name,
            }}
          />
        </Typography>
        <List classes={{ root: s.list }}>
          {changelog.map((item, index) => (
            <React.Fragment key={item._id}>
              <ListItem className={s.item}>
                <ListItemAvatar classes={{ root: s.listItemAvatarRoot }}>
                  <UserAvatar user={item.createdBy} className={s.userAvatar} />
                </ListItemAvatar>
                <ListItemText
                  primary={`${_.get(item, 'createdBy.firstName', '')} ${_.get(
                    item,
                    'createdBy.lastName',
                    '',
                  )}`}
                  classes={{ root: s.listItem }}
                  secondary={
                    <>
                      <Typography variant="body1" color="primary">
                        {moment(item.createDate).format('YYYY-MM-DD HH:mm')}
                      </Typography>
                      <Typography variant="body1" className={s.gray}>
                        {(item.changeDescription || '')
                          .split('\n')
                          .map(line => (
                            <div>{line}</div>
                          ))}
                      </Typography>
                    </>
                  }
                />
              </ListItem>
              {index !== changelog.length - 1 && (
                <Divider variant="inset" component="li" />
              )}
            </React.Fragment>
          ))}
        </List>
        <ModalCloseBtn fitMobileLandscapeFullWidth onClick={onClose} />
      </div>
    );
  }
}
